export const htmlEntityDecode = (input: string): string => {
    if ("string" !== typeof input) return input;
    const tmp = document.createElement("div");
    tmp.innerHTML = input;
    return tmp.textContent;
};
